import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchBalanceModificationTransactionsDelete = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteBalanceModificationTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.delete(serviceUrl, {
    data: {
      comments: payload.params.comments,
      transactionId: payload.params.transactionId,
    },
  });
};

export default apiFetchBalanceModificationTransactionsDelete;
